import { STATE_NAME } from "./register.constants";

export const getError = state => state[STATE_NAME].error;
export const getSuccess = state => state[STATE_NAME].success || false;
